import React from 'react';
import { Box, Tooltip } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { StatusIndicatorProps, StatusType } from './types';

const STATUS_CONFIG: Record<
  StatusType,
  { icon: React.ElementType; color: string }
> = {
  matched: { icon: CheckCircleIcon, color: 'success.main' },
  pending: { icon: MoreHorizIcon, color: 'grey.500' },
  failed: { icon: CancelIcon, color: 'error.main' },
  success: { icon: CheckCircleIcon, color: 'success.main' },
  error: { icon: CancelIcon, color: 'error.main' },
  not_uploaded: { icon: MoreHorizIcon, color: 'grey.500' },
  illio_warning: { icon: WarningAmberIcon, color: 'warning.main' },
};

const STATUS_LABELS: Record<StatusType, string> = {
  matched: 'Matched',
  pending: 'Pending',
  failed: 'Failed',
  success: 'Success',
  error: 'Error',
  not_uploaded: 'Not Uploaded',
  illio_warning: 'Requires manual confirmation in Illio',
};

export const StatusIndicator: React.FC<StatusIndicatorProps> = ({
  status,
  tooltip,
  label,
  className,
}) => {
  const config = STATUS_CONFIG[status];
  const IconComponent = config.icon;

  const tooltipText =
    status === 'illio_warning' ? (
      <span>
        {'Requires manual confirmation in Illio'}
        {tooltip && (
          <>
            <br />
            {tooltip}
          </>
        )}
      </span>
    ) : (
      (tooltip ?? STATUS_LABELS[status])
    );

  const content = (
    <Box
      className={className}
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        height: '100%',
      }}
    >
      <IconComponent sx={{ color: config.color, fontSize: 20 }} />
      {label && <span>{label}</span>}
    </Box>
  );

  return (
    <Tooltip title={tooltipText} placement="top">
      {content}
    </Tooltip>
  );
};
